const breakPoints = {
  desktop: 1204,
  tablet: 1000,
  phone: 600
}

export default breakPoints
